
<template>
    <el-dialog
    title="修改密码"
    :visible.sync="dialogUserEditPwd"
    width="40%"
    :close-on-click-modal="false"
    class="dialogUserEditClass"
    :before-close="handleClose">
        <el-row :span="24">
            <el-form :model="addForm" :rules='rules' label-position="right" label-width="110px" class="inline-input" ref="addForm" style="width:100%;" status-icon>
                <el-row>
                    <el-col :span="21" :offset="1">
                        <el-form-item label="当前账号：" size="mini">
                            <el-input v-model="addForm.name" disabled placeholder="请输入用户账号" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="21" :offset="1">
                        <el-form-item label="当前密码：" prop="oldPwd" size="mini">
                            <el-input v-model.trim="addForm.oldPwd" type="password" placeholder="请输入密码" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="21" :offset="1">
                        <el-form-item label="新密码：" prop="pwds" size="mini">
                            <el-popover
                                ref="popover"
                                placement="right"
                                title=""
                                width="310"
                                trigger="focus">
                                <p class="tipck"><i :class="is816? 'el-icon-circle-check':'el-icon-circle-close'"></i> 8-16个字符</p>
                                <p class="tipck"><i :class="isZuhe? 'el-icon-circle-check':'el-icon-circle-close'"></i> 只能包含字母、数字以及标点符号至少两种（除空格）</p>
                            </el-popover>
                            <el-input v-model.trim="addForm.pwds" @focus="checkRules(addForm.pwds)" @input="checkRules(addForm.pwds)" v-popover:popover show-password auto-complete="new-password" placeholder="请输入新密码" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="21" :offset="1">
                        <el-form-item label="确认新密码：" prop="pwd" size="mini">
                            <el-input v-model.trim="addForm.pwd" type="password" placeholder="请输入新密码" clearable></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </el-row>
        <p style="text-align: left;margin-left: 60px;color:red;font-size: 12px;">
           注意：8-16个字符 ，只能包含字母、数字以及标点符号至少两种（除空格）
        </p>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="setSubmit()">确 定</el-button>
        </span>
    </el-dialog>
</template>
 
<script>
import utils from '../../lib/util'
    export default {
        name:'editPwd',
        data() {
            let reg = /(?!.*\s)(?!^[\u4e00-\u9fa5]+$)(?!^[0-9]+$)(?!^[A-z]+$)(?!^[^A-z0-9]+$)^.{8,16}$/
            var validatePhone = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error('请输入新密码'))
                }
                this.trem1 = setTimeout(() => {
                    if (!reg.test(value)) {
                        callback(new Error('密码设置不符合要求'))
                    } else {
                        callback()
                    }
                }, 400)
            }
            var validate2 = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error('请再次输入新密码'))
                }
                this.trem2 = setTimeout(() => {
                    let reg = /(?!.*\s)(?!^[\u4e00-\u9fa5]+$)(?!^[0-9]+$)(?!^[A-z]+$)(?!^[^A-z0-9]+$)^.{8,16}$/
                    if(this.addForm.pwd != this.addForm.pwds){
                        callback(new Error('两次密码输入不一致，请检查！'))
                    } else if(!reg.test(value)){
                        callback(new Error('密码设置不符合要求'))
                    } else {
                        callback()
                    }  
                }, 400)
            }
            return {
                dialogUserEditPwd: false,
                addForm:{
                    name:'',
                    oldPwd:'',
                    pwd:'',
                    pwds:'',
                },
                rules:{
                    oldPwd :[
                        {required: true, message: '请输入密码', trigger: 'blur'}
                    ],
                    pwds :[
                        {required: true, message: '请输入新密码', trigger: 'blur'},
                        {required: true, validator: validatePhone, trigger: 'blur'}
                    ],
	            	pwd :[
                        {required: true, message: '请再次输入新密码', trigger: 'blur'},
                        {required: true, validator: validate2, trigger: 'blur'},
                    ],
	            },
                is816:false,
                isZuhe:false,
                trem1:null,
                trem2:null,
                trem3:null,
            }
        },
        beforeDestroy(){
            clearTimeout(this.trem1)
            clearTimeout(this.trem2)
        },
        methods:{
            open(info={}){
                this.addForm.name = info.idCardNo
                this.addForm.oldPwd = ''
                this.addForm.pwd = ''
                this.addForm.pwds = ''
                this.dialogUserEditPwd = true
            },
            handleClose(done) {
                this.$refs['addForm'].resetFields()
                utils.empty(this.addForm)
                done();
            },
            checkRules(ver){
                this.is816 = false
                this.isZuhe = false
                if(!ver) return
                let reg1 = /^(([a-zA-Z]+[0-9]+)|([0-9]+[a-zA-Z]+)|([a-z]+[@#%])|([0-9]+[@#%]))([a-zA-Z0-9@#%]*)$/
                if(ver.length>=8&&ver.length<=16) this.is816 = true
                if(reg1.test(ver)) this.isZuhe = true
            },
            setSubmit(){
                let that = this
                if(!that.addForm.oldPwd){
                    that.$message.error('请输入当前密码！');
                    return
                }
                that.$refs['addForm'].validate((valid) => {
                    if (valid) {
                        let reg = /(?!.*\s)(?!^[\u4e00-\u9fa5]+$)(?!^[0-9]+$)(?!^[A-z]+$)(?!^[^A-z0-9]+$)^.{8,16}$/
                        if(that.addForm.pwd != that.addForm.pwds){
                            that.$message.error('两次密码输入不一致，请检查！');
                            return
                        }
                        if(!reg.test(that.addForm.pwd)){
                            that.$message.error('密码设置不符合要求');
                            return
                        }
                        that.$confirm('是否确认修改？修改成功后将返回登录界面', '确认信息', {
                            distinguishCancelAndClose: true,
                            confirmButtonText: '确认修改',
                            cancelButtonText: '取消',
                            type:'warning'
                        })
                        .then(() => {
                            that.$axios.post('/account/updatePwd',{
                                oldPwd:that.$md5(that.addForm.oldPwd.trim()).toLowerCase(),
                                pwd:that.$md5(that.addForm.pwd.trim()).toLowerCase(),
                                uid:Number(that.$base64.decode(window.localStorage.getItem('uid-web'))),
                            }, res => {
                                let v = res.data;
                                if (v.code == 0) {
                                    if(v.data){
                                        that.$notify({
                                            title: '修改密码成功',
                                            type: 'success'
                                        });
                                        utils.empty(that.addForm)
                                        that.$refs['addForm'].resetFields()
                                        that.dialogUserEditPwd = false;

                                        that.$nextTick(()=>{
                                            that.outLogin()
                                        })
                                    }else{
                                        that.$message.error(v.msg)
                                    }
                                } else {
                                    if(v.msg)
                                        that.$message.error(v.msg);
                                    else
                                        that.$message.error('请求错误');
                                }
                            });
                        })
                        .catch(() => {})
                    }
                })
            },
            outLogin(){
                localStorage.removeItem('poorVal')
                let roadNameVal = window.localStorage.getItem('roadName')
                let paramVal = roadNameVal&&roadNameVal=='guangmei'? `/${roadNameVal}`:''
                this.$router.push({
                    path: `${paramVal}/login`,
                })
            }
        }
    }
 </script>
 <style scoped>
    .tipck{
        font-size: 12px;
    }
 </style>
 <style>
    .dialogUserEditClass .el-dialog{
        min-width: 700px;
        max-width: 750px;
    }
    .dialogUserEditClass .el-dialog .el-dialog__header{
        background: #1D4BB0 !important;
    }
    .tipck .el-icon-circle-close{
        color: red !important;
    }
    .tipck .el-icon-circle-check{
        color: green !important;
    }
 </style>


// WEBPACK FOOTER //
// src/pages/myExamList/editPwd.vue